import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import {
  CheckboxQuestion,
  DatePicker,
  InlineDiv,
  RadioButtonQuestion,
  TextInput,
  TextAreaQuestion,
} from "../../../components"

const Container = styled.div``

class IrrReviewForm extends React.Component {
  state = {
  }

  render() {
    const { form, onChange, type } = this.props

    const q1Text = type.hsag
      ? "Did the nurse apply the review criteria appropriately to this case?"
      : "Does the reviewer agree with the nurse’s decision?"

    return (
      <Container>
        <ol>
          <li>
            <RadioButtonQuestion
              id="q1"
              items={RadioButtonQuestion.YesNo}
              value={form["q1"].value}
              onChange={onChange("q1")}
              error={!form["q1"].hasError ? null : true}
              question={q1Text}
              disabled={form["q1"].disabled}
            />
          </li>
          {type.hsag && (
            <React.Fragment>
              <li>
                <RadioButtonQuestion
                  id="q2"
                  items={RadioButtonQuestion.YesNo}
                  value={form["q2"].value}
                  onChange={onChange("q2")}
                  error={!form["q2"].hasError ? null : true}
                  question="Was there sufficient documentation in the record to support the nurse's review decision?"
                  disabled={form["q2"].disabled}
                />
              </li>
              <li>
                <RadioButtonQuestion
                  id="q3"
                  items={RadioButtonQuestion.YesNo}
                  value={form["q3"].value}
                  onChange={onChange("q3")}
                  error={!form["q3"].hasError ? null : true}
                  question="If the case was noncompliant, was it reported to the director for reporting to the State?"
                  disabled={form["q3"].disabled}
                />
              </li>
              <li>
                <RadioButtonQuestion
                  id="q4"
                  items={RadioButtonQuestion.YesNo}
                  value={form["q4"].value}
                  onChange={onChange("q4")}
                  error={!form["q4"].hasError ? null : true}
                  question="Were data entry and documentation tools complete and correct?"
                  disabled={form["q4"].disabled}
                />
              </li>
              <li>
                <RadioButtonQuestion
                  id="q5"
                  items={RadioButtonQuestion.YesNo}
                  value={form["q5"].value}
                  onChange={onChange("q5")}
                  error={!form["q5"].hasError ? null : true}
                  question="Is there concurrence with the nurse reviewer's determination on the case?"
                  disabled={form["q5"].disabled}
                />
              </li>
            </React.Fragment>
          )}
        </ol>
        <TextAreaQuestion
          question="Comments"
          value={form["comment"].value}
          onChange={onChange("comment")}
          disabled={form["comment"].disabled}
        />
      </Container>
    )
  }
}

IrrReviewForm.propTypes = {
  form: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  type: PropTypes.shape({
    hsag: PropTypes.bool.isRequired,
    mqd: PropTypes.bool.isRequired,
  }).isRequired,
}

export default IrrReviewForm



// WEBPACK FOOTER //
// ./src/modules/record/components/IrrReviewForm.js